// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g8clrIERujCAmPNBFogJ{display:flex;align-items:center;gap:4px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/BillingPlan/ui/PlanIncludesTooltipContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA","sourcesContent":[".tooltipContentTitle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContentTitle": `g8clrIERujCAmPNBFogJ`
};
export default ___CSS_LOADER_EXPORT___;
